"use client"
/* */
import { createElement } from 'react';

class ItemView {
  list;
  textValue;
  href;
  defaultExpanded;
  fallback;
  showTiles;
  showList;
  tileMaxWidth;
  renderFn;
  constructor(list, shape = {}) {
    const {
      fallback,
      textValue,
      href,
      defaultExpanded,
      renderFn,
      showTiles,
      showList = true,
      tileMaxWidth = 230
    } = shape;
    this.list = list;
    this.textValue = textValue;
    this.renderFn = renderFn;
    this.href = href;
    this.defaultExpanded = defaultExpanded;
    this.fallback = fallback;
    this.showTiles = showTiles;
    this.showList = showList;
    this.tileMaxWidth = tileMaxWidth;
  }
  static fallbackRenderItemFn = (item) => createElement("pre", void 0, JSON.stringify(item));
  render(data) {
    const renderFn = this.renderFn ?? ItemView.fallbackRenderItemFn;
    return renderFn(data, this.list);
  }
}

export { ItemView };
//# sourceMappingURL=ItemView.mjs.map
